import { FETCH_SINGLE_USER_DATA_FAILURE, FETCH_SINGLE_USER_DATA_REQUEST, FETCH_SINGLE_USER_DATA_SUCCESS } from "./actionCreator";


const initialState = {
  loading: false,
  error: null,
  users: []
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SINGLE_USER_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_SINGLE_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        error: null
      };
    case FETCH_SINGLE_USER_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default usersReducer;
